export default __webpack_public_path__ + "static/plane-65269de50cb8dc2a65029dc686dc205e.png";